import { StandardConfigurationAssetTeamBase } from './base/standard-configuration-asset-team-base';

export class StandardConfigurationAssetTeam extends StandardConfigurationAssetTeamBase { }